import { DataStore } from './DataStore';
import { HttpService } from './HttpService';
import { I18nService } from './I18nService';
import { ServiceLocator } from './ServiceLocator';
import { installerFactory } from './VueServiceInstaller';
// TODO: Inject an event channel into uScope instead of importing it here because this sets up a weird circular dependency.
import uScopeApi from 'uScope/js/public-api';

export default {
  /**
     * installs all services into Vue
     * @param Vue
     * @param options - { dataServerPath, bearerToken }
     */
  async install (Vue, {options}) {
    if (!Vue.$services) {
      // Attach the service locator to the Vue global and each instance.
      Vue.use(installerFactory({
        name: '$services',
        service: new ServiceLocator()
      }));

      // Expose a handy event channel to be shared between non-Vue and Vue-centric code
      Vue.use(installerFactory({
        name: '$events',
        service: uScopeApi.events
      }));

      // Install the HTTP Service.
      Vue.use(HttpService);

      // Create the data store. Needs http.
      Vue.use(DataStore, {
        ...options,
        uScopeApi
      });

      // Install the internationalization service (abbreviated i18n).
      Vue.use(I18nService, options);
      I18nService.init();
    }
  }
};



// WEBPACK FOOTER //
// ./src/shared/services/index.js